import React, {useEffect, useState, useRef} from "react";
import {ADOBEDTM_PAGE_NAME} from "../../constants";
import {useDispatch, useSelector} from "react-redux";
import {API, processApiResponse} from "../../services/HttpHandler";
// import {dataDashboard} from "../../util";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CancelConfirmBox from "../../components/CancelPopUp";
import BlockBtn from "../../components/BlockBtn";
import RTEAppointment from "../../components/RTEAppointment";
import Loader from "../../components/Loader";
import TabsMenu from "../../components/TabsMenu";
import {
  setAppointmentDetails,
  setCurrentAppointment,
} from "../../actions/appointment";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";

import "./style.scss";
import "../../components/Loader/style.scss";
import config from "config";

const OfficeAppointments = () => {
  const [currentAppointment, setCurrentAppn] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openCancelConfirm, setOpenCancelConfirm] = useState(false);
  const [showAppointmentMenu, setShowAppointmentMenu] = useState(false);
  const [currentAppnList, setCurrentAppnList] = useState([]);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const isOffice = updatedCustomerSlotDetails.current.isOffice;
  const dispatch = useDispatch();
  const {selectedAppn} = useSelector((state) => {
    return {
      selectedAppn: state.appnDetails.selectedAppn,
    };
  });
  const performAction = () => {
    // commenting to hide covid questions
    // navigate("/customer/officeQuestions");
    navigate("/customer/selectStore");
  };
  const fetchUserLatestBookingPBU = async () => {
    try {
      setLoading(true);
      const current = updatedCustomerSlotDetails.current;
      updatedCustomerSlotDetails.current.existingBookingDetails = null;
      const prepareURL = `?office=${current.isOffice}`;
      const url =
        `${config.endPoints.perBuBookings}/${current.userId}` + prepareURL;
      let response = await API.get(url);
      response = await processApiResponse(response);
      if (response.length && response.length > 0) {
        const currentAppointments = response.map((r) =>
          Object.values(r)
            .flat()
            .filter((a) => a.status !== "expired")
        );

        const tempArray = currentAppointments
          .flatMap((a) => Object.values(a))
          .flat();

        setCurrentAppnList(tempArray);
        if (tempArray.length === 1) {
          getQRData(tempArray[0]);
        }
        return true;
      }
      return false;
    } catch (errorMessage) {
      setCurrentAppnList([]);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const agreeCancel = () => {
    let cancelInfo = {
      bookingId: currentAppointment.uuid,
      userId: currentAppointment.userId,
    };
    updatedCustomerSlotDetails.current.cancelDetail = cancelInfo;
    setCustomerSlotDetails(updatedCustomerSlotDetails.current);
    setCurrentAppn(null);
    navigate("/customer/cancelAppointments");
  };

  const cancelConfirm = () => {
    // const datamap = new Map();
    // if (isOffice) {
    //   datamap.set("events", "event54=1");
    // } else {
    //   datamap.set("events", "event17=1");
    // }
    // dataDashboard(datamap);
    setOpenCancelConfirm(true);
  };

  useEffect(() => {
    // const URL = window.location.href.split("/")[2];
    // const officeApp = isOffice ? URL + "/office" : URL + "/app";
    // const datamap = new Map();
    // datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Display_Bookings);
    // datamap.set("prop1", URL);
    // datamap.set("prop2", officeApp);
    // dataDashboard(datamap);
    fetchUserLatestBookingPBU();
  }, []);

  const cancelAction = (appointment) => {
    setCurrentAppn(appointment);
    setShowAppointmentMenu(true);
  };

  const getQRData = (appn) => {
    const qrDataUrl = config.endPoints.qrdata;
    const bookingIdPlaceHolder = /bookingIdPlaceholder/gi;
    const url = qrDataUrl.replace(bookingIdPlaceHolder, appn.uuid);

    try {
      setLoading(true);
      API.get(url)
        .then(processApiResponse)
        .then((resp) => {
          updatedCustomerSlotDetails.current.appointmentuuid = resp.uuid;
          setCustomerSlotDetails(updatedCustomerSlotDetails.current);
          dispatch(setAppointmentDetails(resp));
          dispatch(setCurrentAppointment(resp.uuid));
        });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const showDetailedContent = (app) => {
    if (selectedAppn === app.uuid) {
      dispatch(setCurrentAppointment(""));
    } else {
      getQRData(app);
    }
  };

  const undoCancel = () => {
    setShowAppointmentMenu(false);
    setOpenCancelConfirm(false);
    setCurrentAppn(null);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <TabsMenu path="displayAppointments" />
      <div className="main-container">
        <RTEAppointment
          appointmentsDetails={currentAppnList}
          menuHandler={cancelAction}
          infoHandler={showDetailedContent}
        />
        {showAppointmentMenu && (
          <div className="appointment-menu-container">
            <div className="appointment-menu">
              <button
                className="trash-img-cancle-btn-container"
                onClick={cancelConfirm}
              >
                <div className="thrash-icon" />
                <div className="cancel-reservation-text">
                  {t("cancelBooking.label")}
                </div>
              </button>
            </div>
          </div>
        )}
        {openCancelConfirm && (
          <CancelConfirmBox
            title={t("cancel.reservation.title")}
            storeName={currentAppointment.storeName}
            close={() => undoCancel()}
            performAction={() => agreeCancel()}
            isOffice={isOffice}
          />
        )}
        {currentAppnList.length === 0 ? (
          <div className="displayAppointment-footer">
            <BlockBtn
              name={t("login.label")}
              handleClick={performAction}
              disabled={false}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default OfficeAppointments;
